// extracted by mini-css-extract-plugin
var _1 = "Loader_loader__Cefhx";
var _2 = "Loader_loaderWrapper__7bP9E";
var _3 = "Loader_massive__bxmLg";
var _4 = "Loader_normal__hm5Fl";
var _5 = "Loader_spin__zYmqV";
export { _1 as "loader", _2 as "loaderWrapper", _3 as "massive", _4 as "normal", _5 as "spin" }
